import { addClass, removeClass } from '../../utils/CommonUtils';
const NAVBAR_CLASS_EXPANDED = 'is-expanded';

function closeAllNavbarDropdowns(noClosingException) {
	document.querySelectorAll('li' + (noClosingException ? ':not(.navbar-tablet__dropdown)' : '')).forEach((el) => {
		removeClass(el, NAVBAR_CLASS_EXPANDED);
	});
	document.querySelectorAll('.navbar-tablet__dropdown-link-icon.-icon-single-arrow-up-line').forEach((el) => {
		removeClass(el, '-icon-single-arrow-up-line');
		addClass(el, '-icon-single-arrow-down-line');
	});
}

function onClick(event) {
	const target = event.target || event;
	const parent = target.closest('li');
	const state = !parent.classList.contains(NAVBAR_CLASS_EXPANDED);

	closeAllNavbarDropdowns(target.closest('a').classList.contains('navbar-tablet__dropdown-link'));

	if (!state) {
		removeClass(parent, NAVBAR_CLASS_EXPANDED);
	} else {
		addClass(parent, NAVBAR_CLASS_EXPANDED);
	}

	if (parent.id !== 'navbar-tablet-dropdown') {
		parent.querySelectorAll('.-icon-single-arrow-down-line,.-icon-single-arrow-up-line').forEach((el) => {
			if (state) {
				removeClass(el, '-icon-single-arrow-down-line');
				addClass(el, '-icon-single-arrow-up-line');
			} else {
				removeClass(el, '-icon-single-arrow-up-line');
				addClass(el, '-icon-single-arrow-down-line');
			}
		});
	}

	if (typeof event === 'object' && event.cancelable) {
		event.preventDefault();
	}
}

export { onClick, closeAllNavbarDropdowns };
